import React, { Suspense } from 'react';
import ReactTooltip from 'react-tooltip';
import { withTranslation } from 'react-i18next';
import { Spinner } from '@livingsecurity/cyberblocks';
import { getEntranceExamGenData, getEntranceExamStoreData, getEntranceExamBriefData } from '../data';

import '../utils/i18n';

class ExamGuide extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.getInitialData(),
      activeFile: {},
      activeTab: 'guide',
    };

    this.getInitialData();
  }

  getInitialData = () => {
    if (this.props.puzzle === 'storeexam' || window.location.href.indexOf('storeexam') > -1) {
      return getEntranceExamStoreData();
    } else if (this.props.puzzle === 'briefexam' || window.location.href.indexOf('briefexam') > -1) {
      return getEntranceExamBriefData();
    } else {
      return getEntranceExamGenData();
    }
  };

  toggleActiveFile = (file) => {
    this.setState({ activeFile: this.state.activeFile.src ? {} : file });
  };

  renderFile = (file) => {
    const { t } = this.props;
    return (
      <div
        className='file'
        style={{ backgroundImage: `url(${file.src})`, textAlign: 'center' }}
        onClick={this.toggleActiveFile.bind(this, file)}
      >
        <div className='footer'>{t(file.nameKey)}</div>
      </div>
    );
  };

  renderPuzzle = (file) => {
    const { t } = this.props;
    return (
      <a href={file.url} target='_blank' rel='noreferrer'>
        <div className='file' style={{ backgroundImage: `url(${file.src})` }}>
          <div className='footer'>{t(file.nameKey)}</div>
        </div>
      </a>
    );
  };

  toggleView = (nextView) => {
    this.setState({ activeTab: nextView });
  };

  render() {
    const { t, embedded } = this.props;
    const { activeFile, data, activeTab } = this.state;
    const { backgroundImage, files, puzzles } = data;
    const activeData = activeTab === 'guide' ? files : puzzles;

    return (
      <div className='dashboard-container' style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className='main-container'>
          {embedded ? (
            <div className='header'>{t('exam-guide')}</div>
          ) : (
            <nav className='toggle-nav'>
              <div
                className={`toggle-item ${activeTab === 'guide' ? 'active' : ''}`}
                onClick={this.toggleView.bind(this, 'guide')}
              >
                Exam Guide
              </div>
              <div
                className={`toggle-item ${activeTab === 'puzzles' ? 'active' : ''}`}
                onClick={this.toggleView.bind(this, 'puzzles')}
              >
                Puzzles
              </div>
            </nav>
          )}
          <div className='file-container'>
            {activeData.map((item) => (activeTab === 'guide' ? this.renderFile(item) : this.renderPuzzle(item)))}
          </div>
        </div>
        {activeFile.src && (
          <div className='active-file' onClick={this.toggleActiveFile}>
            <ReactTooltip place='top' effect='solid' type='light' delayShow={1000} />
            <i className='far fa-times' onClick={this.toggleActiveFile} data-tip={`${t('close-file')}`} />
            <img src={activeFile.src} alt={activeFile.nameKey} data-tip={`${t(activeFile.clueKey)}`} />
          </div>
        )}
      </div>
    );
  }
}

const Loader = () => (
  <div className='dashboard-container'>
    <Spinner />
  </div>
);

const ExamGuideView = withTranslation()(ExamGuide);

export default function Dashboard() {
  return (
    <Suspense fallback={<Loader />}>
      <ExamGuideView />
    </Suspense>
  );
}
